import { useEffect, useState } from "react";

export type HomeV2Theme = "light" | "dark";

const STORAGE_KEY = "employher-hv2-theme";

const getInitialTheme = (): HomeV2Theme => {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === "light" || saved === "dark") {
      return saved;
    }
  } catch {
    // localStorage unavailable (private mode, etc.) — fall through to OS preference
  }

  const prefersDark = window.matchMedia?.("(prefers-color-scheme: dark)").matches;
  return prefersDark ? "dark" : "light";
};

// Mirrors the mockup's own theme JS: saved localStorage choice wins, else
// the OS's prefers-color-scheme, else light. Applied via a data-theme
// attribute on the .home-v2 root (see _homeV2.scss) rather than the
// mockup's body.light/body.dark, since this page can't touch <body>.
const useTheme = () => {
  const [theme, setTheme] = useState<HomeV2Theme>(getInitialTheme);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // ignore write failures
    }
  }, [theme]);

  const toggleTheme = () => setTheme((current) => (current === "dark" ? "light" : "dark"));

  return { theme, toggleTheme };
};

export default useTheme;
